import React from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../images/Logo.png';
import About from '../elements/About';
import Portfolio from '../elements/Portfolio';
import Footer from '../elements/Footer';
import Contacto from '../elements/Contacto';
import { 
  ContenedorInicio, 
  GridOverlay,
  ContenedorPequeno, 
  Badge, 
  Titulo, 
  Subtitulo, 
  BotoneraHero, 
  BotonPrimario, 
  BotonSecundario 
} from '../styles/front-page.styles';
import Caja from '../styles/components/box.styles';

const Inicio = () => {
    return (
        <>
            <Helmet>
                <link rel="shortcut icon" href={ favicon } type="image/x-icon" data-react-helmet="true"/>
            </Helmet>

            <Caja>
                <ContenedorInicio className='ContenidoMain'>
                    {/* Malla de ingeniería/fondo sutil para quitar lo plano */}
                    <GridOverlay />

                    <ContenedorPequeno className='contenedorPequeno'>
                        <Badge>
                            <span className="dot" />
                            <span>Disponible para nuevos proyectos</span>
                        </Badge>
                        
                        <Titulo>
                            Desarrollo plataformas web y sistemas a la medida que <span className='highlight'>impulsan tu negocio.</span>
                        </Titulo>
                        
                        <Subtitulo>
                            Soy <strong>Alan Jiménez</strong>, desarrollador fullstack. Ayudo a empresas a transformar procesos complejos en software seguro, rápido y de alto rendimiento.
                        </Subtitulo>

                        <BotoneraHero>
                            <BotonPrimario href="/contact">
                                Cotizar proyecto
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </BotonPrimario>
                        
                            <BotonSecundario href="/portfolio">
                                Ver casos de estudio
                            </BotonSecundario>
                        </BotoneraHero>
                    </ContenedorPequeno>
                </ContenedorInicio>

                <About className="about"></About>
                <Portfolio></Portfolio>
                <Contacto></Contacto>
                <Footer></Footer>
            </Caja>
        </>

    );
}
 
export default Inicio;